export default (params) => ({
  trigger: {
    name: 'product_plus.read_terms_and_conditions',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'nespresso',
          'norton',
          'vendor_free_with',
          'free_washing',
          'free_drying',
        ],
      },
    },
    event: {
      name: 'select_navigation',
    },
  },
});
